export default __webpack_public_path__ + "static/media/m_ceoLanding02.975ea00e.png";